import { createAsyncThunk } from "@reduxjs/toolkit";
import proxyApi from "services/apis/proxyApi";
import ruleEngine from "services/apis/ruleEngine";

export const fetchDatastreamList = createAsyncThunk(
  "datastream/fetchList",
  async (companyId, thunkAPI) => {
    try {
      const response = await proxyApi.getDataStreamConfig({ companyId });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);

export const fetchDatastreamVersions = createAsyncThunk(
  "datastream/fetchVersions",
  async (dsConfigId, thunkAPI) => {
    try {
      const response = await ruleEngine.getAllDSConfigVersionByDSConfigId({
        dsConfigId,
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);
